import { SCEventName, SCWebhookPayload } from '../types/webHookTypes';

export const scWebHookExtractLanguages = (payload: SCWebhookPayload): string[] => {
  switch (payload.EventName) {
    case SCEventName.ItemAdded:
    case SCEventName.ItemDeleted:
    case SCEventName.ItemSaved:
      return [payload.Item.Language];
    case SCEventName.PublishComplete:
      return payload['DistributedPublishOptions[]'].map((po) => po.LanguageName);
    default:
      return [];
  }
};

export const scWebHookExtractItemId = (payload: SCWebhookPayload): string[] => {
  switch (payload.EventName) {
    case SCEventName.ItemAdded:
    case SCEventName.ItemDeleted:
    case SCEventName.ItemSaved:
      return [payload.Item.Id];
    case SCEventName.PublishComplete:
      return payload['DistributedPublishOptions[]'].map((po) => po.RootItemId);
    default:
      return [];
  }
};
